<app-change-password-component [data]="data" [dialogRef]="dialogRef"></app-change-password-component>